import { LOGOUT } from '../../../store/Types';

export const USU_ENTIDAD_LOGIN = 'USUA_ENTIDAD_LOGIN';
export const USER_LOGIN = 'USER_LOGIN';
export const VISTAS_LOGIN = 'VISTAS_LOGIN';

export const ROOT_CONST = 'root';
export const ADMIN_CONST = 'admin';
export const ENTITY_CONST = 'entity';
export const TEACHER_CONST = 'teacher';
export const FAMILY_CONST = 'family';
export const STUDENT_CONST = 'student';
export const USER_CONST = 'user';

const initialState = {
  user: null,
  rol: null,
  vistas: [],
  usuEntidad: null,
  isRoot: false,
  isAdmin: false,
  isEntity: false,
  isTeacher: false,
  isFamily: false,
  isStudent: false,
  isUser: false,
  isAdminTeacher: false,
};

export const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case USU_ENTIDAD_LOGIN:
      return {
        ...state,
        usuEntidad: action.payload,
      };
    case VISTAS_LOGIN:
      return {
        ...state,
        vistas: action.payload,
      };
    case USER_LOGIN:
      return {
        ...state,
        user: action.payload.user,
        rol: action.payload.user.rol,
        isRoot: action.payload.user.rol === ROOT_CONST,
        isAdmin: action.payload.user.rol === ADMIN_CONST,
        isEntity: action.payload.user.rol === ENTITY_CONST,
        isTeacher: action.payload.user.rol === TEACHER_CONST,
        isFamily: action.payload.user.rol === FAMILY_CONST,
        isStudent: action.payload.user.rol === STUDENT_CONST,
        isUser: action.payload.user.rol === USER_CONST,
        isAdminTeacher:
          action.payload.user.admin &&
          action.payload.user.rol === TEACHER_CONST,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};
